import { IconUser16 } from '@warp-ds/icons/react/user-16';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { CustomSelect } from '../common/CustomSelect';

type AgePickerProps = {
    value: string;
    onChange: (value: number) => void;
    className?: string;
};

type AgeOption = {
    value: string;
    label: string;
    labelPrefix?: string;
};

const defaultAgeOption: AgeOption = {
    value: '25-70',
    label: 'Sjåfør mellom 25-70 år',
};

const generateAgeOptions = (): AgeOption[] => {
    const options: AgeOption[] = [];

    for (let age = 18; age < 25; age++) {
        options.push({
            value: age.toString(),
            label: age.toString(),
            labelPrefix: 'Sjåførens alder: ',
        });
    }

    options.push({
        value: defaultAgeOption.value,
        label: defaultAgeOption.label,
    });

    for (let age = 71; age <= 99; age++) {
        options.push({
            value: age.toString(),
            label: age.toString(),
            labelPrefix: 'Sjåførens alder: ',
        });
    }

    return options;
};

export const AgePicker = ({ value, onChange }: AgePickerProps) => {
    const isGroupedAge = Number(value) >= 25 && Number(value) <= 70;
    const mappedValue = isGroupedAge ? defaultAgeOption.value : value;
    const isSmallScreen = useBreakpoints({ breakpoint: 'sm' });

    const handleChange = (val: string) => {
        if (val === defaultAgeOption.value) {
            onChange(30);
        } else {
            onChange(Number(val));
        }
    };

    return (
        <CustomSelect
            slim
            triggerIcon={isSmallScreen ? <IconUser16 /> : undefined}
            fullscreenTitle="Hvor gammel er sjåføren?"
            value={mappedValue}
            onChange={handleChange}
            options={generateAgeOptions()}
        />
    );
};
